import React from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { DotRed } from 'src/layouts/Default'
import useMedia from 'use-media'
import { LeftArrow, RightArrow } from './styles'

function Carroussel({ list }) {
	const responsive = {
		desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 767 },
      items: 2,
      slidesToSlide: 2
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
      slidesToSlide: 1
    }
	}

	const isMobile = useMedia({ maxWidth: 768 })

	return (
		<Carousel
			showArrows
			showDots={isMobile}
			autoSlide={false}
			responsive={responsive}
			ssr
			infinite={false}
			autoPlay={false}
			customDot={<DotRed />}
			keyBoardControl
			customLeftArrow={
				<LeftArrow src="/bradescoclassic/assets/chevron_right.svg" />
			}
			customRightArrow={
				<RightArrow src="/bradescoclassic/assets/chevron_right.svg" />
			}
		>
			{list}
		</Carousel>
	)
}

export default Carroussel
